import Raven from 'raven-js';
import formatName from 'I18n/utils/formatName';
import { List as ImmutableList } from 'immutable';
import { deriveNestedTeamIds, getUserIdsInViewableTeams } from './teamUtils';
export const getOwnerIdFromURL = location => {
  const OWNER_ID_INDEX = 2;
  if (!location) {
    return null;
  }
  const pathNames = location.pathname.split('/');
  if (pathNames.length !== OWNER_ID_INDEX + 1) {
    return null;
  }
  const ownerId = Number(pathNames[OWNER_ID_INDEX]);
  return ownerId;
};
export const getPermissionedOwnerFromURL = (location, ownerIdToUserIdMap, ownerIdsWithPermissions, owners) => {
  const ownerId = getOwnerIdFromURL(location);
  if (!ownerId || !ownerIdsWithPermissions.includes(ownerId)) {
    return null;
  }
  return owners.get(ownerIdToUserIdMap.get(ownerId));
};
export const getFormattedName = owner => {
  const firstName = owner.get('firstName');
  const lastName = owner.get('lastName');
  const email = owner.get('email');
  if (!firstName && !lastName) {
    return email;
  }
  return formatName({
    firstName,
    lastName,
    email
  });
};
export const getUserActivationStatus = (ownersMap, userId) => {
  if (!userId || !ownersMap.get(userId)) {
    Raven.captureMessage('userId does not exist or does not exist within ownersMap', {
      extra: {
        userId
      }
    });
    return 'unknown';
  }
  return ownersMap.get(userId).get('isActive') ? 'active' : 'inactive';
};

// This function filters the users that we display in the User and Team search
export const getViewableUsers = ({
  canViewAll,
  canViewTeam,
  currentUserId,
  userPrimaryTeam,
  teams,
  userIdsWithPerms
}) => {
  const userPrimaryTeamId = userPrimaryTeam && userPrimaryTeam.get('id');
  const userTeamIds = deriveNestedTeamIds(userPrimaryTeamId, teams);
  const hasNoTeams = !teams || !teams.size;
  const hasViewOnlySelfPermissions = !canViewAll && !canViewTeam;

  // Owned only view permissions
  if (hasNoTeams || hasViewOnlySelfPermissions) {
    return ImmutableList([currentUserId]);
  }

  // Team only view permissions
  if (!canViewAll && canViewTeam && userPrimaryTeam) {
    // Intersect users with permissions (users who can appear in the app) with users in the teams this user has access to
    const userIdsInTeam = userTeamIds.length && getUserIdsInViewableTeams(teams, userTeamIds);
    const viewableUsers = userIdsWithPerms && userIdsInTeam ? userIdsInTeam.toSet().intersect(userIdsWithPerms.toSet()).toList() : ImmutableList();
    return viewableUsers;
  }
  return userIdsWithPerms;
};